export default {
    unlock: 'hordeAreaMonkeyJungle',
    icon: 'mdi-temple-hindu',
    color: 'teal',
    zones: {
        1: {
            x: 8,
            y: -2,
            unlockedBy: null,
            type: 'regular',
            difficulty: 33,
            enemyType: ['strongMonkey', 'monkeyWizard_1']
        },
        2: {
            x: 5,
            y: -4,
            unlockedBy: '1',
            type: 'regular',
            difficulty: 36,
            enemyType: ['strongMonkey', 'monkeyWizard_1']
        },
        3: {
            x: 3,
            y: -5.5,
            unlockedBy: '2',
            type: 'regular',
            difficulty: 38,
            enemyType: ['monkeyWizard_1', 'monkeyWizard_2', 'monkeyWizard_3', 'monkeyDefender']
        },
        4: {
            x: 2,
            y: -3,
            unlockedBy: '2',
            type: 'regular',
            difficulty: 39,
            enemyAmount: 150,
            enemyType: ['strongMonkey', 'angryMonkey', 'dartMonkey', 'monkeyMonk']
        },
        5: {
            x: 0,
            y: -5,
            unlockedBy: '3',
            type: 'regular',
            difficulty: 40,
            enemyType: ['monkeyWizard_1', 'monkeyWizard_2', 'monkeyWizard_3', 'monkeyDefender']
        },
        6: {
            x: -2,
            y: -3.5,
            unlockedBy: ['4', '5'],
            type: 'regular',
            difficulty: 43,
            enemyType: ['angryMonkey', 'monkeyWizard_2']
        },
        7: {
            x: -5,
            y: -4,
            unlockedBy: '6',
            type: 'regular',
            difficulty: 46,
            enemyType: ['dartMonkey', 'monkeyWizard_3']
        },
        8: {
            x: -6,
            y: -0.5,
            unlockedBy: '7',
            type: 'regular',
            difficulty: 49,
            enemyType: ['strongMonkey', 'angryMonkey', 'monkeyWizard_1', 'monkeyWizard_2']
        },
        9: {
            x: -8,
            y: 1,
            unlockedBy: '8',
            type: 'regular',
            difficulty: 51,
            enemyAmount: 150,
            enemyType: ['strongMonkey', 'angryMonkey', 'dartMonkey', 'monkeyMonk']
        },
        10: {
            x: -4,
            y: -1.5,
            unlockedBy: '8',
            type: 'regular',
            difficulty: 52,
            enemyType: ['monkeyWizard_1', 'monkeyWizard_2', 'monkeyWizard_3', 'monkeyDefender']
        },
        11: {
            x: -7.5,
            y: 4,
            unlockedBy: '9',
            type: 'regular',
            difficulty: 56,
            enemyAmount: 50,
            enemyType: ['strongMonkey', 'angryMonkey', 'dartMonkey', 'monkeyMonk']
        },
        12: {
            x: -2.5,
            y: 1,
            unlockedBy: '10',
            type: 'regular',
            difficulty: 55,
            enemyType: ['monkeyWizard_1', 'monkeyWizard_2', 'monkeyWizard_3', 'monkeyDefender']
        },
        13: {
            x: -4,
            y: 3,
            unlockedBy: ['11', '12'],
            type: 'regular',
            difficulty: 58,
            enemyAmount: 150,
            enemyType: ['angryMonkey', 'dartMonkey', 'monkeyWizard_2', 'monkeyWizard_3']
        },
        14: {
            x: -0.5,
            y: 4,
            unlockedBy: '13',
            type: 'regular',
            difficulty: 62,
            enemyType: ['strongMonkey', 'dartMonkey', 'monkeyWizard_1', 'monkeyWizard_3']
        },
        15: {
            x: 2,
            y: 6,
            unlockedBy: '14',
            type: 'regular',
            difficulty: 64,
            enemyType: ['strongMonkey', 'angryMonkey', 'dartMonkey', 'monkeyMonk']
        },
        16: {
            x: 3.5,
            y: 1.5,
            unlockedBy: '14',
            type: 'regular',
            difficulty: 66,
            enemyType: ['monkeyWizard_1', 'monkeyWizard_2', 'monkeyWizard_3', 'monkeyDefender']
        },
        17: {
            x: 5,
            y: 5,
            unlockedBy: '15',
            type: 'regular',
            difficulty: 67,
            enemyType: ['strongMonkey', 'angryMonkey', 'dartMonkey', 'monkeyMonk']
        },
        18: {
            x: 7.5,
            y: 2,
            unlockedBy: ['16', '17'],
            type: 'regular',
            difficulty: 69,
            enemyType: ['angryMonkey', 'dartMonkey', 'monkeyWizard_2', 'monkeyWizard_3']
        },
        19: {
            x: 2.5,
            y: -0.5,
            unlockedBy: '18',
            type: 'regular',
            difficulty: 72,
            enemyType: ['strongMonkey', 'angryMonkey', 'dartMonkey', 'monkeyWizard_1', 'monkeyWizard_2', 'monkeyWizard_3']
        },
        boss_1: {
            x: -1,
            y: -1.5,
            unlockedBy: '19',
            type: 'boss',
            difficulty: 75,
            boss: ['chriz1', 'chriz2'],
            reward: 'hordeAreaLoveIsland'
        },
        endless: {
            x: 4,
            y: -2,
            unlockedBy: '19',
            type: 'endless',
            difficulty: 75,
            enemyType: ['strongMonkey', 'angryMonkey', 'dartMonkey', 'monkeyWizard_1', 'monkeyWizard_2', 'monkeyWizard_3']
        }
    },
    decoration: [
        {x: 8.2, y: -3.4, rotate: 0, icon: 'mdi-tent', size: 2},
        {x: 9, y: -1.4, rotate: 0, icon: 'mdi-campfire', size: 1},
        {x: 4.8, y: -6, rotate: 0, icon: 'mdi-palm-tree', size: 1.2},
        {x: 5.6, y: -6.4, rotate: 0, icon: 'mdi-tree', size: 1},
        {x: 7, y: -5.5, rotate: 0, icon: 'mdi-palm-tree', size: 1.8},
        {x: 7.3, y: -6.25, rotate: 0, icon: 'mdi-koala', size: 0.5},
        {x: 8.1, y: -6.6, rotate: 0, icon: 'mdi-grass', size: 0.6},
        {x: 9.3, y: -6.2, rotate: 0, icon: 'mdi-palm-tree', size: 1.4},
        {x: 8.9, y: -5.7, rotate: 0, icon: 'mdi-grass', size: 0.6},
        {x: 5.8, y: -4.4, rotate: 0, icon: 'mdi-grass', size: 0.6},
        {x: 1, y: -4, rotate: 0, icon: 'mdi-tree', size: 1},
        {x: 2.2, y: -4.3, rotate: 0, icon: 'mdi-palm-tree', size: 1},
        {x: 1.5, y: -6, rotate: 0, icon: 'mdi-grass', size: 0.6},
        {x: 2.6, y: -6.3, rotate: 0, icon: 'mdi-grass', size: 0.6},
        {x: -5, y: -6.1, rotate: 0, icon: 'mdi-palm-tree', size: 1.6},
        {x: -3, y: -5.5, rotate: 0, icon: 'mdi-palm-tree', size: 2.5},
        {x: -3.85, y: -5.55, rotate: 0, icon: 'mdi-spider-thread', size: 0.5},
        {x: -1.25, y: -5.8, rotate: 0, icon: 'mdi-tree', size: 1.1},
        {x: -9.5, y: -6.5, rotate: 0, icon: 'mdi-tree', size: 1},
        {x: -7, y: -6, rotate: 0, icon: 'mdi-tree', size: 1.45},
        {x: -4, y: -4.2, rotate: 0, icon: 'mdi-grass', size: 0.6},
        {x: -7.2, y: -4.6, rotate: 0, icon: 'mdi-grass', size: 0.6},
        {x: -8.5, y: -5, rotate: 0, icon: 'mdi-elephant', size: 1.1},
        {x: -7.4, y: -3.5, rotate: 0, icon: 'mdi-elephant', size: 1.25},
        {x: -9, y: -4.2, rotate: 0, icon: 'mdi-elephant', size: 0.8},
        {x: -8.5, y: -3.2, rotate: 0, icon: 'mdi-grass', size: 0.6},
        {x: -9.4, y: -2.4, rotate: 0, icon: 'mdi-palm-tree', size: 1.3},
        {x: -9.7, y: -0.7, rotate: 0, icon: 'mdi-tree', size: 1.1},
        {x: -7.8, y: -1.2, rotate: 0, icon: 'mdi-tree', size: 1.3},
        {x: -6.1, y: -2.7, rotate: 0, icon: 'mdi-tree', size: 1.2},
        {x: -6.35, y: -1, rotate: 0, icon: 'mdi-grass', size: 0.6},
        {x: -8.9, y: 0.8, rotate: 0, icon: 'mdi-palm-tree', size: 1.5},
        {x: -9.5, y: 2, rotate: 0, icon: 'mdi-palm-tree', size: 1},
        {x: -8.7, y: 2.5, rotate: 0, icon: 'mdi-grass', size: 0.6},
        {x: -8.3, y: 3.4, rotate: 0, icon: 'mdi-palm-tree', size: 1.2},
        {x: -9.7, y: 3.7, rotate: 0, icon: 'mdi-tortoise', size: 0.5},
        {x: -5.5, y: 1.5, rotate: 0, icon: 'mdi-volcano', size: 2},
        {x: -6.7, y: 1, rotate: 0, icon: 'mdi-tree', size: 1},
        {x: -6.6, y: 2.7, rotate: 0, icon: 'mdi-grass', size: 0.6},
        {x: -4.4, y: -0.1, rotate: 0, icon: 'mdi-palm-tree', size: 1.2},
        {x: -3.7, y: 1.3, rotate: 0, icon: 'mdi-palm-tree', size: 1},
        {x: -4, y: -2.5, rotate: 0, icon: 'mdi-palm-tree', size: 1.35},
        {x: -2.8, y: -2.8, rotate: 0, icon: 'mdi-grass', size: 0.6},
        {x: -0.5, y: -1.8, rotate: 0, icon: 'mdi-palm-tree', size: 0.8},
        {x: -1, y: -2.3, rotate: 0, icon: 'mdi-tree', size: 0.8},
        {x: -1.5, y: -1.9, rotate: 0, icon: 'mdi-palm-tree', size: 0.8},
        {x: -1.7, y: -1.2, rotate: 0, icon: 'mdi-palm-tree', size: 0.8},
        {x: -1.2, y: -0.7, rotate: 0, icon: 'mdi-palm-tree', size: 0.8},
        {x: -0.6, y: -0.9, rotate: 0, icon: 'mdi-grass', size: 0.5},
        {x: 1.4, y: -2.1, rotate: 0, icon: 'mdi-grass', size: 0.6},
        {x: 3.8, y: -0.9, rotate: 0, icon: 'mdi-grass', size: 0.6},
        {x: 1.7, y: 1, rotate: 0, icon: 'mdi-palm-tree', size: 1.2},
        {x: -1, y: 2.1, rotate: 0, icon: 'mdi-palm-tree', size: 1},
        {x: -0.5, y: 2.6, rotate: 0, icon: 'mdi-grass', size: 0.6},
        {x: 4, y: 2.8, rotate: 0, icon: 'mdi-palm-tree', size: 1.3},
        {x: 1.2, y: 3.9, rotate: 0, icon: 'mdi-grass', size: 0.6},
        {x: 2.75, y: 4.6, rotate: 0, icon: 'mdi-kangaroo', size: 0.75},
        {x: 6.6, y: 0.8, rotate: 0, icon: 'mdi-grass', size: 0.6},
        {x: 4.7, y: 6, rotate: 0, icon: 'mdi-palm-tree', size: 1.1},
        {x: 8.6, y: 3.5, rotate: 0, icon: 'mdi-palm-tree', size: 1.6},
        {x: 7.3, y: 4.2, rotate: 0, icon: 'mdi-grass', size: 0.6},
        {x: 8.1, y: 6.3, rotate: 0, icon: 'mdi-snake', size: 0.5},
        {x: 9.5, y: 5.6, rotate: 0, icon: 'mdi-grass', size: 0.6},
        {x: -9.9, y: 6.25, rotate: 0, icon: 'mdi-waves', size: 1},
        {x: -9.9, y: 7, rotate: 0, icon: 'mdi-waves', size: 1},
        {x: -9.05, y: 6.25, rotate: 0, icon: 'mdi-waves', size: 1},
        {x: -9.05, y: 7, rotate: 0, icon: 'mdi-waves', size: 1},
        {x: -8.2, y: 6, rotate: 0, icon: 'mdi-waves', size: 1},
        {x: -8.2, y: 6.9, rotate: 0, icon: 'mdi-shark-fin', size: 1},
        {x: -7.35, y: 6.25, rotate: 0, icon: 'mdi-waves', size: 1},
        {x: -7.35, y: 7, rotate: 0, icon: 'mdi-waves', size: 1},
        {x: -7.35, y: 5.75, rotate: 0, icon: 'mdi-wave', size: 1},
        {x: -6.5, y: 6.25, rotate: 0, icon: 'mdi-waves', size: 1},
        {x: -6.5, y: 7, rotate: 0, icon: 'mdi-waves', size: 1},
        {x: -6.5, y: 5.75, rotate: 0, icon: 'mdi-wave', size: 1},
        {x: -5.65, y: 6.25, rotate: 0, icon: 'mdi-waves', size: 1},
        {x: -5.65, y: 7, rotate: 0, icon: 'mdi-waves', size: 1},
        {x: -5.65, y: 5.75, rotate: 0, icon: 'mdi-wave', size: 1},
        {x: -5.65, y: 5.5, rotate: 0, icon: 'mdi-wave', size: 1},
        {x: -4.8, y: 6.25, rotate: 0, icon: 'mdi-waves', size: 1},
        {x: -4.8, y: 7, rotate: 0, icon: 'mdi-waves', size: 1},
        {x: -4.8, y: 5.75, rotate: 0, icon: 'mdi-wave', size: 1},
        {x: -4.8, y: 5.5, rotate: 0, icon: 'mdi-wave', size: 1},
        {x: -3.95, y: 6.25, rotate: 0, icon: 'mdi-waves', size: 1},
        {x: -3.95, y: 7, rotate: 0, icon: 'mdi-waves', size: 1},
        {x: -3.95, y: 5.75, rotate: 0, icon: 'mdi-wave', size: 1},
        {x: -3.95, y: 5.5, rotate: 0, icon: 'mdi-wave', size: 1},
        {x: -3.1, y: 6.25, rotate: 0, icon: 'mdi-waves', size: 1},
        {x: -3.1, y: 7, rotate: 0, icon: 'mdi-waves', size: 1},
        {x: -3.1, y: 5.75, rotate: 0, icon: 'mdi-wave', size: 1},
        {x: -2.25, y: 6.25, rotate: 0, icon: 'mdi-waves', size: 1},
        {x: -2.25, y: 7, rotate: 0, icon: 'mdi-waves', size: 1},
        {x: -1.4, y: 7, rotate: 0, icon: 'mdi-waves', size: 1},
        {x: -1.4, y: 6.5, rotate: 0, icon: 'mdi-wave', size: 1},
        {x: -0.55, y: 7.25, rotate: 0, icon: 'mdi-wave', size: 1},
        {x: -9.2, y: 5.45, rotate: 0, icon: 'mdi-palm-tree', size: 1},
        {x: -5, y: 4.85, rotate: 0, icon: 'mdi-palm-tree', size: 1.2},
        {x: -3.2, y: 5.2, rotate: 0, icon: 'mdi-palm-tree', size: 1},
        {x: -0.4, y: 6.6, rotate: 0, icon: 'mdi-palm-tree', size: 1.1},
    ]
}
